// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3e4ns","header":"MergedInvoice_header__1AJYH"};